import { required, numeric, integer, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";
import numeral from 'numeral';

export default function (formState, cashInDrawer) {
  return {
    form: {
      amount: {
        required: helpers.withMessage(i18n.global.t('Please enter a amount.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the amount.'), numeric),
        maxValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Insufficient cash in drawer') +  '('+i18n.global.t('_POS.Available')+': ฿'+numeral($params.max).format("0,0.00")+')'
        , maxValue(cashInDrawer))
      },
      shift_transaction_category_id: {
        required: helpers.withMessage(i18n.global.t('Please enter a category.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      note: {
      }
    }
  }
};
